import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useStore = create(
  persist(
    (set) => ({
      user:         null,
      token:        null,
      institution:  null,  // current school/hospital/restaurant
      module:       'school', // school | hospital | pos | restaurant
      activeScreen: 'dashboard',
      online:       navigator.onLine,
      pendingSync:  0,

      setUser:        user  => set({ user }),
      setToken:       token => { localStorage.setItem('cognira_token', token); set({ token }); },
      setInstitution: inst  => set({ institution: inst }),
      setModule:      mod   => set({ module: mod, activeScreen: 'dashboard' }),
      setScreen:      scr   => set({ activeScreen: scr }),
      setOnline:      val   => set({ online: val }),
      setPendingSync: n     => set({ pendingSync: n }),
      logout: () => {
        localStorage.removeItem('cognira_token');
        set({ user: null, token: null });
      },
    }),
    {
      name: 'cognira-storage',
      partialize: s => ({ user: s.user, token: s.token, module: s.module, institution: s.institution })
    }
  )
);
